/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TimelineLite} from "gsap";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {EGRS2Symbol} from "../../symbol/EGRS2Symbol";
import {EGRS1Symbol} from "../../symbol/EGRS1Symbol";
import {ElGordosRevengeSound} from "../../sound/ElGordosRevengeSound";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin():boolean {
        const data = ElGordosRevenge.model.parsedGameData;
        return !data.mode.includes(GameMode.FREESPIN) && data.nextMode.includes(GameMode.FREESPIN);
    }

    protected async createWinAnimation():Promise<any> {
        const data = ElGordosRevenge.model.parsedGameData;
        const tl = new TimelineLite();
        tl.add(() => {
            ElGordosRevenge.initialCountUp.remove();
            ElGordosRevenge.bigWinCountUp.remove();
            ElGordosRevenge.waysWon.remove();
            // SlotGame.keypadPlugin.hide();
        });
        tl.add(() => {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.SCATTER_BURN});
        });
        let delay = 0;
        data.S1Positions!.forEach((symId, reelId) => {
            if(symId > -1) {
                const symbol = <EGRS1Symbol>ElGordosRevenge.reels[reelId].getSymbol(symId);
                const symTl = new TimelineLite();
                symTl.add(symbol.playWin());
                tl.add(symTl, delay);
                delay += 0.1;
            }
        });
        if(data.showCylinder) {
            const s2 = <EGRS2Symbol>ElGordosRevenge.reels[5].getSymbol(0);
            tl.add([
                () => {
                    ElGordosRevenge.reels[5].reelView.addWinSymbol(s2);
                    ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.SCATTER_BURN_S2});
                },
                s2.playWinSuper()
            ], delay);
        }
        tl.add(() => {}, `+=0.1`);
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            ElGordosRevenge.freespinIntro.show(() => {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(ElGordosRevenge.fsMeter.getCurrentLevelFSLeft());
                resolve();
            });
        });
    }
}